/* global axios */
// Meta Ads MCP koprusu - tum sayfalarin ortak veri erisimi.
//
// Chatwoot kimlik basliklarini AYRI bir axios ornegine koyar ve onu
// window.axios olarak yayinlar. "import axios from 'axios'" ham kutuphaneyi
// getirir, basliklar gitmez ve istek 401 doner. Global ornek kullanilmali.

/** Tek giris noktasi: 136 MCP aracinin tamami buradan cagrilir. */
export async function aracCalistir(accountId, arac, argumanlar = {}, secenek = {}) {
  const { data } = await axios.post(`/api/v1/accounts/${accountId}/reklam/arac`, {
    arac,
    argumanlar,
    onaylandi: secenek.onaylandi === true,
  });
  return data.sonuc ?? {};
}

/** Kullanilabilir araclarin listesi ve girdi semalari. */
export async function aracListesi(accountId) {
  const { data } = await axios.get(`/api/v1/accounts/${accountId}/reklam/araclar`);
  return data.araclar ?? [];
}

/**
 * Arac sonucundan tablo icin dizi cikarir.
 * MCP araclari veriyi bazen dogrudan dizi, bazen {data: [...]} , bazen
 * {campaigns: [...]} gibi tek anahtarli nesne icinde dondurur.
 */
export function diziyeCevir(sonuc) {
  const veri = sonuc?.veri;
  if (Array.isArray(veri)) return veri;
  if (veri && typeof veri === 'object') {
    const dizi = Object.values(veri).find(v => Array.isArray(v));
    if (dizi) return dizi;
    return [veri];
  }
  return [];
}

/** Meta tutarlari kurus cinsinden dondurur. */
export function paraBicimle(kurus, birim = 'TRY') {
  const sayi = Number(kurus || 0) / 100;
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: birim }).format(sayi);
}

/** Buyuk sayilari okunur hale getirir (gosterim, tiklama vb.). */
export function sayiBicimle(deger) {
  return new Intl.NumberFormat('tr-TR').format(Number(deger || 0));
}

/**
 * Secili reklam hesabini oturum boyunca hatirlar. Her sayfa ayri ayri hesap
 * sormasin diye; kullanici bir kez secer, tum Meta Ads sayfalari onu kullanir.
 */
const ANAHTAR = 'satispilot_meta_ads_hesap';

export function seciliHesabiOku() {
  try {
    return window.localStorage.getItem(ANAHTAR) || '';
  } catch {
    return '';
  }
}

export function seciliHesabiYaz(id) {
  try {
    window.localStorage.setItem(ANAHTAR, id || '');
  } catch {
    // Gizli sekmede yazilamayabilir; sayfa yine calisir.
  }
}
